import { render, staticRenderFns } from "./LmUploadFiles.vue?vue&type=template&id=fda4cc3a&scoped=true"
import script from "./LmUploadFiles.vue?vue&type=script&lang=js"
export * from "./LmUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./LmUploadFiles.vue?vue&type=style&index=0&id=fda4cc3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda4cc3a",
  null
  
)

export default component.exports